import { resolverHost, resolverUrls, resolverExternalUrls, resolverBraspag, resolverSuccessCodes } from '../app/config/remote-config.store';

export const environment = {
  appId: 'treino',
  envId: 'stage',
  configUrl: 'https://frontendgate-api.cfw.actuar.cloud',
  stage: true,
  production: false,
  development: false,
  local: false,
  sentryDsn: '',
};


export const enum Protocol {
  http = 'http://',
  https = 'https://',
  wss = 'wss://',
}

/**
 * Chaves de serviço, não endereços. O host real é resolvido em runtime a partir
 * da configuração baixada no boot — ver src/app/config/.
 *
 * Deixou de ser `const enum` porque o TypeScript inlina const enums em tempo de
 * compilação: depois do build não existe objeto nenhum, só as strings coladas no
 * código, e nada em runtime consegue mudá-las.
 */
export enum EntityPath {
  odata = 'odata',
  odata_arquivar_acessos = 'odata_arquivar_acessos',
  odata_access_log_service = 'odata_access_log_service',
  base = 'base',
  afig = 'afig',
  paguela = 'paguela',
  chat = 'chat',
  file_group = 'file_group',
  workout_service = 'workout_service',
  workout_view = 'workout_view',
  activity_service = 'activity_service',
  user_service = 'user_service',
  shortener = 'shortener',
  post_service = 'post_service',
  account_service = 'account_service',
  receivable_service = 'receivable_service',
  client_notification = 'client_notification',
  acesso = 'acesso',
  graduation_service = 'graduation_service',
  client_device_service = 'client_device_service',
  physical_assessment_service = 'physical_assessment_service',
  storage_service = 'storage_service',
  file_group_service = 'file_group_service',
  person_service = 'person_service',
  subscription_service = 'subscription_service',
  data_service = 'data_service',
  contract_service = 'contract_service',
  access_log_service = 'access_log_service',
}

/**
 * Getters em vez de constantes: o valor só existe depois de o boot aplicar a
 * configuração. Os call sites (`URLS.treino_web`) continuam idênticos.
 */
export const URLS = {
  get actuar_web() { return resolverUrls()['actuar_web']; },
  get new_actuar_web() { return resolverUrls()['new_actuar_web']; },
  get treino_web() { return resolverUrls()['treino_web']; },
  get sign_view() { return resolverUrls()['sign_view']; },
  get paguela_web() { return resolverUrls()['paguela_web']; },
  get link_shortener() { return resolverUrls()['link_shortener']; },
  get whatsapp_redirect() { return resolverUrls()['whatsapp_redirect']; },
};

export const braspag = {
  get providerMerchantId() { return resolverBraspag().providerMerchantId; },
  get providerOrgId() { return resolverBraspag().providerOrgId; },
};

/**
 * Os 86 call sites que passam por aqui não mudaram: a assinatura é a mesma. O
 * que mudou é que `entityPath` agora é uma CHAVE, resolvida em runtime, em vez
 * de ser o próprio host.
 */
export const url = (
  protocol: Protocol,
  entityPath: EntityPath,
  restUrl?: any
) => `${protocol}${resolverHost(entityPath)}${restUrl}`;

export const successCodesCheckout: string[] = new Proxy([] as string[], {
  get: (_alvo, prop) => (resolverSuccessCodes() as unknown as Record<PropertyKey, unknown>)[prop],
});

/**
 * Endereços de TERCEIROS. Separados de `URLS` porque a validação é outra: host
 * exato, nunca sufixo de domínio. Ver remote-config.allowlist.ts.
 */
export const EXTERNAL_URLS = {
  get app_store() { return resolverExternalUrls()['app_store']; },
  get play_store() { return resolverExternalUrls()['play_store']; },
  get ip_lookup() { return resolverExternalUrls()['ip_lookup']; },
  get device_fingerprint() { return resolverExternalUrls()['device_fingerprint']; },
  get youtube_embed() { return resolverExternalUrls()['youtube_embed']; },
  get youtube_channel() { return resolverExternalUrls()['youtube_channel']; },
  get facebook() { return resolverExternalUrls()['facebook']; },
  get x() { return resolverExternalUrls()['x']; },
  get instagram() { return resolverExternalUrls()['instagram']; },
};
